/* global console */
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Button, makeStyles } from "@fluentui/react-components";
import { resize } from "../../../state/structureSlice";
import { SpacerWidth1, SpacerWidth2, SpacerWidth3, SpacerWidth4, SpacerWidth5 } from "../../../assets/icons";

const useClasses = makeStyles({
  PanelButton: {
    justifyContent: "left",
    fontFamily: "Arial",
    fontSize: 9,
    fontWeight: 400,
    letterSpacing: "0.02em",
  },
});

const buttonStyles = {
  selected: { backgroundColor: "#F5F5F5" },
  unselected: { backgroundColor: "transparent" },
};

const SpacerMenuItem = () => {
  const classes = useClasses();
  const { t } = useTranslation();
  const selection = useSelector((state) => state.selection);
  const structure = useSelector((state) => state.gridd.present.structure);
  const currentStyleSheet = useSelector(
    (state) => state.styleSheet.sheets[state.styleSheet.selectedSheet] ?? state.styleSheet.sheets["default"]
  );

  const isVerticalSpacer = selection.columns.length > 0;
  const isHorizontalSpacer = selection.rows.length > 0;

  let currentSpacerWeight = null;
  if (isVerticalSpacer && selection.columns[0] !== undefined) {
    currentSpacerWeight = structure.columns[selection.columns[0]];
  } else if (isHorizontalSpacer && selection.rows[0] !== undefined) {
    currentSpacerWeight = structure.rows[selection.rows[0]];
  }

  const dispatch = useDispatch();

  const getSpacerIcon = (spacerWidth) => {
    const iconMap = {
      compact: SpacerWidth1,
      cozy: SpacerWidth2,
      comfortable: SpacerWidth3,
      spacious: SpacerWidth4,
      expansive: SpacerWidth5,
    };
    return iconMap[spacerWidth.name] || SpacerWidth3;
  };

  return (
    <div>
      <div
        style={{
          display: "grid",
          gridTemplateRows: "auto",
        }}
      >
        {currentStyleSheet?.spacerWidths?.map((sw) => {
          const SpacerIcon = getSpacerIcon(sw);

          return (
            <Button
              key={sw.name}
              id={`size_${sw.width}`}
              icon={<SpacerIcon />}
              appearance="subtle"
              style={currentSpacerWeight === "s" + sw.width ? buttonStyles.selected : buttonStyles.unselected}
              className={classes.PanelButton}
              onClick={() => {
                console.log(`Selected spacer width: ${sw.width}`);
                dispatch(
                  resize({
                    columnIndex: isVerticalSpacer ? selection.columns[0] : undefined,
                    rowIndex: isHorizontalSpacer ? selection.rows[0] : undefined,
                    weight: "s" + sw.width,
                  })
                );
              }}
            >
              {t("menu.style.spacers." + sw.name)}
            </Button>
          );
        })}
      </div>
    </div>
  );
};

export default SpacerMenuItem;
